module.exports = __webpack_public_path__ + "media/hyper/images/payments/visa-e690f4a204e37ee326c0a887262d1030.png";